import { createClient } from "@supabase/supabase-js";

const supabaseUrl = String(import.meta.env.VITE_SUPABASE_URL || "").trim();
const supabaseAnonKey = String(import.meta.env.VITE_SUPABASE_ANON_KEY || "").trim();

function isValidSupabaseUrl(value) {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return (
      (parsed.protocol === "https:" || parsed.protocol === "http:") &&
      parsed.hostname.includes("supabase.co")
    );
  } catch {
    return false;
  }
}

export const supabaseConfigError = !supabaseUrl
  ? "VITE_SUPABASE_URL fehlt."
  : !isValidSupabaseUrl(supabaseUrl)
    ? "VITE_SUPABASE_URL ist ungueltig. Erwartet wird z. B. https://deinprojekt.supabase.co"
    : !supabaseAnonKey
      ? "VITE_SUPABASE_ANON_KEY fehlt."
      : null;

export const hasSupabaseConfig = Boolean(!supabaseConfigError);

let supabaseClient = null;
if (hasSupabaseConfig) {
  try {
    supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    });
  } catch {
    supabaseClient = null;
  }
}

export const supabase = supabaseClient;
